// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/css/simplebar.css
// module id = 2256
// module chunks = 5